import {
  REQUEST_PRIVACY_POLICY,
  RECEIVE_PRIVACY_POLICY,
  REQUEST_ACCEPT_PRIVACY_POLICY,
  RECEIVE_ACCEPT_PRIVACY_POLICY,
} from 'ondemand/actions/privacyPolicy';

export default function privacyPolicy(state = {
  isFetching: false,
  accepted: null,
}, action) {
  switch (action.type) {
    case REQUEST_PRIVACY_POLICY:
      return {...state, isFetching: true};
    case RECEIVE_PRIVACY_POLICY:
      return {...state, isFetching: false, accepted: action.accepted};
    case REQUEST_ACCEPT_PRIVACY_POLICY:
      return {...state, isFetching: true};
    case RECEIVE_ACCEPT_PRIVACY_POLICY:
      return {...state, isFetching: false, accepted: true};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/ondemand/reducers/privacyPolicy.js